export default "__VITE_ASSET__c0342442__"